<template>
  <v-autocomplete
    v-model="academicFilter"
    :items="listAcademic"
    item-text="title"
    label="Chọn cấp"
    return-object
    @change="onChange"
    hide-details
    dense
    outlined
    class=" mt-0 pb-6"
  ></v-autocomplete>
</template>

<script>
import { AcademicLevel } from '@/plugins/api'

export default {
  data: () => ({
    level: '',
    listAcademic: [],
    academicFilter: null
  }),
  props: {
    defaultLevel: {
      type: Object,
      default: () => ({})
    }
  },
  async created() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.listAcademic = await AcademicLevel.fetch({ status: 'active' })

      if (this.defaultLevel) {
        this.academicFilter = this.defaultLevel._id
      } else {
        this.academicFilter = this.listAcademic[1] ? this.listAcademic[1].id : null
      }

      this.$emit('change', this.academicFilter)
    },
    onChange() {
      // Emit only the id of the selected academic level
      this.$emit('change', this.academicFilter)
    }
  }
}
</script>
